import { Injectable, OnDestroy, isDevMode, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, Subject } from 'rxjs';
import { tap, share, finalize, switchMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from './authentication.service';
import { HubConnection } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';

@Injectable()
export class OnlineUsersService implements OnDestroy {

  private _hubConnection: HubConnection | undefined;

  public onlineUsers: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  constructor(authService: AuthenticationService) {
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('/hubs/users', { accessTokenFactory: () => authService.accessToken })
      .configureLogging(isDevMode() ? signalR.LogLevel.Information : signalR.LogLevel.Error)
      .build();

    this._hubConnection.on('updateUsers', (data: any) => {
      this.onlineUsers.next(data);
    });

    this.hubRestart();
  }

  ngOnDestroy() {
    this._hubConnection.stop();
  }

  private async hubRestart() {
    await this._hubConnection.stop();
    await this._hubConnection.start();
  }
}
